import { Button, Dialog, DialogActions, DialogContent, TextField } from "@mui/material";
import { Component } from "react";
import DialogTitleWithCloseButton from "../../../components/DialogTitleWithCloseButton";
import { errorToast } from "../../../toast";
import request from "../../../request";
import swal from "sweetalert";
import { hideLoading, showLoading } from "../../../loading";


export default class PasswordEditor extends Component {

   submit = async () => {

      // extract values
      const txtOldPassword = document.getElementById('txt-old-password');
      const txtNewPassword = document.getElementById('txt-new-password');
      const txtConfirm = document.getElementById('txt-confirm');

      const old_password = txtOldPassword.value;
      const new_password = txtNewPassword.value;
      const confirm = txtConfirm.value;

      // validate
      if (!old_password) {
         errorToast("Please enter your current password");
         return txtOldPassword.focus();
      }

      if (!new_password) {
         errorToast("Please enter your new password");
         return txtNewPassword.focus();
      }

      if (!confirm) {
         errorToast("Please confirm your new password");
         return txtConfirm.focus();
      }

      if (confirm !== new_password) {
         errorToast("Passwords do not match");
         txtNewPassword.value = '';
         txtConfirm.value = '';
         return txtNewPassword.focus();
      }

      // send request
      try {

         showLoading();

         await request.post('/api/auth/password-update', { old_password, new_password });
         swal("Success", "Password updated", "success");
         this.props.onClose();
      } catch (err) {
         swal("Error", err.message, "error");
      } finally {
         hideLoading();
      }

   }

   render() {
      return <Dialog open>
         <DialogTitleWithCloseButton onClose={this.props.onClose}>
            Update Password
         </DialogTitleWithCloseButton>
         <DialogContent dividers>
            <div className="max-w-full w-[250px] flex flex-col gap-4 pt-4">
               <TextField
                  id="txt-old-password"
                  label="Current Password"
                  size="small"
                  variant="outlined"
                  fullWidth
                  type="password"
               />
               <TextField
                  id="txt-new-password"
                  label="New Password"
                  size="small"
                  variant="outlined"
                  fullWidth
                  type="password"
               />
               <TextField
                  id="txt-confirm"
                  label="Confirm Password"
                  size="small"
                  variant="outlined"
                  type="password"
                  fullWidth
               />
            </div>
         </DialogContent>
         <DialogActions>
            <Button onClick={this.submit} variant="contained">Update</Button>
         </DialogActions>
      </Dialog>
   }
}